import styles from './Search.module.css';
import { ReactComponent as SearchIcon } from '../../assets/Search icon.svg';

const Search = () => {
  return (
    <form className={styles.wrapper}>
        <div className={styles.inputWrapper}>
            <input className={styles.search} placeholder='Search a song of your choice'/>
        </div>
        <div>
            <button className={styles.searchButton} type='submit'>
                <SearchIcon />
            </button>
        </div>
    </form>
  )
}

export default Search;